var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Help@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Help",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(-1.000000, 2.000000)",
    fill: "#B7844D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58837085,17 L5.93746821,16.7046633 L5.93746821,13.1253409 L1.56898355,13.1253409 C0.703589704,13.1253409 -2.09078294e-16,12.4384209 -2.09078294e-16,11.5951419 L-2.09078294e-16,1.53019895 C-2.09078294e-16,0.686197259 0.703589704,0 1.56898355,0 L17.4176595,0 C18.2904823,0 19,0.691997258 19,1.54394847 L19,11.595179 C19,12.438458 18.2956693,13.1253779 17.4310165,13.1253779 L11.3004705,13.1253779 L6.58837085,17 Z M1.56894574,0.771438706 C1.14070432,0.771438706 0.791883171,1.11241376 0.791883171,1.53008777 L0.791883171,11.5942895 C0.791883171,12.0133904 1.14070432,12.3528849 1.56894574,12.3528849 L6.3330106,12.3528849 L6.72859098,12.7386867 L6.72859098,15.8743919 L10.8996651,12.4447954 L11.1549873,12.3528682 L17.4301235,12.3528682 C17.8598469,12.3528682 18.2079462,12.0133922 18.2079462,11.5950141 L18.2079462,1.54378355 C18.2079462,1.11816002 17.8531779,0.771438706 17.4167664,0.771438706 L1.56894574,0.771438706 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89551408,9.65086386 C9.89551408,10.1655072 9.10433431,10.1655072 9.10433431,9.65086386 C9.10433431,9.13622054 9.89551408,9.13622054 9.89551408,9.65086386",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89551408,8.4927172 L9.10359331,8.4927172 L9.10359331,7.93319339 C9.10359331,7.31068493 9.46503066,6.74463844 10.0721573,6.41963469 C10.5248897,6.1764239 10.7586849,5.69361572 10.6681308,5.19199924 C10.5850058,4.72729521 10.1938714,4.34655218 9.71812991,4.26548192 C9.35891556,4.20323107 9.00933422,4.29298837 8.73620895,4.51738345 C8.46678869,4.738154 8.31241353,5.06171238 8.31241353,5.40409759 L8.31241353,5.7898994 L7.52049276,5.7898994 L7.52049276,5.40409759 C7.52049276,4.83299231 7.77877901,4.29372217 8.22780645,3.92528329 C8.67683389,3.55684441 9.27058447,3.40483998 9.85542405,3.50401439 C10.6532728,3.64082023 11.3078805,4.27924997 11.4474166,5.05809896 C11.5965972,5.87749235 11.1973004,6.69614452 10.4536206,7.09569585 C10.1047993,7.28316737 9.89549508,7.59586697 9.89549508,7.93245218 L9.89551408,8.4927172 Z",
    id: "Fill-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.6be88605d00353d5cb66c06eb2340c4b.svg";
export { ForwardRef as ReactComponent };